import { FC, useCallback } from "react";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import {
  initiateBudgetForCreate,
  setCurrentBudgetData,
} from "@/store/budgets/budgetsSlice";
import { getResourceExplorerDataByBudgetThunk } from "@/store/budgets/thunks/getResourceExplorerDataByBudgetThunk";
import { toggleAlertsOpenDrawer } from "@/store/alerts/alertsSlice";
import { resourceExplorerIdSelector } from "@/store/resource-explorer/selectors/current-resource-explorer/resourceExplorerIdSelector";
import { useAppAbility } from "@/services/permissions";

interface ResourceExplorerBudgetSelectFooterProps {
  onClose(): void;
}

export const ResourceExplorerBudgetSelectFooter: FC<
  ResourceExplorerBudgetSelectFooterProps
> = ({ onClose }) => {
  const dispatch = useAppDispatch();
  const viewId = useAppSelector(resourceExplorerIdSelector);
  const { can } = useAppAbility();
  const canCreateBudget = can("create", "budget");

  const toggleBudgetsAndAlertsDrawer = useCallback(() => {
    dispatch(initiateBudgetForCreate());
    dispatch(setCurrentBudgetData({ viewId }));
    dispatch(getResourceExplorerDataByBudgetThunk());
    dispatch(toggleAlertsOpenDrawer());
    onClose();
  }, [dispatch, viewId, onClose]);

  if (!canCreateBudget) {
    return null;
  }
  return (
    <Button
      onClick={toggleBudgetsAndAlertsDrawer}
      startIcon={<AddIcon />}
      fullWidth
      sx={{ justifyContent: "start", px: 2, py: 1 }}
    >
      Create Budget
    </Button>
  );
};
